export default "__VITE_ASSET__WTRMzkzp__"